"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_radio_button_1 = require("./awsui-radio-button");
var util_1 = require("../../runtime/util");
var RadioGroupWrapper = /** @class */ (function (_super) {
    __extends(RadioGroupWrapper, _super);
    function RadioGroupWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioGroupWrapper.prototype.findButtons = function () {
        return this.findAll('awsui-radio-button').map(function (r) { return new awsui_radio_button_1.default(r.getElement()); });
    };
    RadioGroupWrapper.prototype.findInputByValue = function (value) {
        var safeValue = util_1.escapeSelector(value);
        return this.find("input[value=\"" + safeValue + "\"]");
    };
    /**
     * Find an underlying native control by `controlId` property
     * @deprecated use `findInputByValue` instead
     */
    RadioGroupWrapper.prototype.findInputById = function (id) {
        return this.find("input#" + id);
    };
    return RadioGroupWrapper;
}(dom_1.ComponentWrapper));
exports.default = RadioGroupWrapper;
//# sourceMappingURL=awsui-radio-group.js.map